/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */// Mot being used
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import Urls from '../../utils/urls';
import apiBackendInstance from '../../utils/axios';
import { prefixPath } from '../../utils/helpers';

function ProtocolContactUsBody() {
  const [titleValidationMessage, setTitleValidationMessage] = useState(false as boolean|string);
  const [descriptionValidationMessage, setDescriptionValidationMessage] = useState(false as boolean|string);
  const [networkName, setNetworkname] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [redirect, setRedirect] = useState('');

  const paths = [
    { name: 'Home', path: prefixPath('/dashboard') },
    { name: 'Marketplace', path: prefixPath('/marketplace') },
  ];

  const getNetworkNameParams = () => {
    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });
    const { name } = params;
    setNetworkname(name);
  };

  useEffect(() => {
    getNetworkNameParams();
    window.scrollTo(0, 0);
  }, []);

  if (redirect) {
    return <Navigate to={redirect} />;
  }

  const submit = async () => {
    const payload = {
      name: networkName,
      title,
      description,
    };
    apiBackendInstance.post(Urls.getProtocolContactUsUrl(), { ...payload }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },

    })
      .then((response) => {
        if (response.data.success) {
          const div2 = document.getElementById('success_div');
          if (div2) div2.style.display = 'block';
          setTimeout(() => setRedirect(prefixPath('/marketplace')), 3000);
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      }).catch((err) => {
        const div2 = document.getElementById('error_div');
        if (div2) div2.style.display = 'block';
        setTimeout(() => setRedirect(prefixPath('/marketplace')), 3000);
      });
  };
  const titleRule = ():boolean => {
    if (title === '' || title.trim().length === 0) {
      setTitleValidationMessage('Title is required');
      return false;
    }
    return true;
  };

  const descriptionRule = ():boolean => {
    if (description === '' || description.trim().length === 0) {
      setDescriptionValidationMessage('Description is required');
      return false;
    }
    return true;
  };

  const validate = ():boolean => {
    let flag = true;
    if (!titleRule()) {
      flag = false;
    }
    if (!descriptionRule()) {
      flag = false;
    }
    return flag;
  };

  return (
    <section className="px-5 col-12 workspace">
      <div id="success_div" className="alert alert-success fade show mt-5 col-11 mx-auto" style={{ display: 'none' }} role="alert">Your query submitted successfully.</div>
      <div id="error_div" className="alert alert-danger fade show mt-5 col-11 mx-auto" style={{ display: 'none' }} role="alert">There was an error. Please try again later.</div>
      <div className="mt-5 col-11 mx-auto">
        <div className="cursor d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <Breadcrumb prefixLink={paths} activeLink="Contact Us" />
          </div>
        </div>
      </div>
      <div className="card my-4 col-11 mx-auto">
        <div className="card-body p-0">
          <div className="mb-3  col-11 mx-auto">
                          <label htmlFor="" className="mb-1 mt-2 col-form-label label-1">
                            Protocol Name
                            <span className="text-danger mx-1">*</span>
                          </label>
                          <input
                            type="text"
                            value={networkName}
                            className="form-control col-11"
                            readOnly
                            placeholder="Title"
                          />
          </div>
          <div className="mb-3  col-11 mx-auto">
                        <label htmlFor="" className="mb-1 mt-2 col-form-label label-1">
                          Title
                          <span className="text-danger mx-1">*</span>
                        </label>
                        <input
                          type="text"
                          onChange={(e) => { setTitle(e.target.value); }}
                          className={`form-control col-11 ${titleValidationMessage ? 'is-invalid' : ''}`}
                          onFocus={() => { setTitleValidationMessage(false); }}
                          id=""
                          required
                          placeholder="Title"
                        />
          </div>
          {titleValidationMessage !== false && (
                <div className="text-danger text-left col-11 mx-auto">
                      {titleValidationMessage}
                </div>
          )}
          <div className="mb-3  col-11 mx-auto">
                        <label htmlFor="" className="mb-1 mt-2 col-form-label label-1">
                        Description
                          <span className="text-danger mx-1">*</span>
                        </label>
                        <textarea
                          className={`form-control col-11 ${descriptionValidationMessage ? 'is-invalid' : ''}`}
                          onChange={(e) => { setDescription(e.target.value); }}
                          onFocus={() => { setDescriptionValidationMessage(false); }}
                          id=""
                          rows={12}
                          cols={50}
                          required
                          placeholder="Description"
                        />
          </div>
          {descriptionValidationMessage !== false && (
                <div className="text-danger text-left col-11 mx-auto mb-3">
                      {descriptionValidationMessage}
                </div>
          )}
          <div className="mb-3  col-11 mx-auto">
            <button type="button" id="contactUsBtn" className="btn btn-primary mb-2" onClick={() => { if (validate()) submit(); }}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProtocolContactUsBody;
